export default {
  cart: {
    saleSavingsAmount: "You're saving {amount} by booking on konfetti",
    voucherSavings: "You're saving {amount} with the code {code}",
    discount: 'Discount',
    giftcardTitle: 'Gift card',
    giftbox: {
      title: 'Gift card incl. shipping',
      price: 'only {price}',
      addButtonLabel: 'Add',
      addedButtonLabel: 'Remove',
    },
    shippingTotal: 'Shipping costs',
    grandTotal: 'Total',
    shippingTotalSubline: 'incl. VAT., plus shipping costs',
    removeGiftbox: 'Remove gift box option',
    checkoutButton: 'Proceed to Checkout',
    continueShopping: 'Continue Shopping',
    multiDateCard: {
      title: 'Your class has {count} dates',
    },
    emptyCart: {
      title: 'Woops! Your cart is empty',
      description: "Looks like you haven't added any items to the cart yet.",
    },
    removeItem: {
      cancel: 'Cancel',
      label: 'Remove item',
      message: 'Article removed',
    },
    itemRemoved: {
      title: 'Product Removed!',
      message: ':product has been successfully removed from your cart.',
    },
    validation: {
      modalTitle: 'There was an error while we were validating your cart...',
      goToEvent: 'To event page',
    },
    giftcard: 'Gift card',
    giftcardAddons: {
      PDF: {
        title: 'Gift card to print at home',
        description: 'Digital gift card that you receive as a PDF by email',
      },
      CARD: {
        title: 'Gift card sent per mail',
        description:
          'High-quality card in envelope (2-5 days shipping) - includes a PDF by email',
      },
      BOX: {
        title: 'Gift box sent per mail',
        description:
          'Premium box incl. gift card (2-5 days shipping) - includes a PDF by email',
      },
    },

    cartItem: {
      priceUpdated: 'This item had price updates.',
    },

    itemsInfo: {
      title: 'About your purchase',
      iconsLabels: {
        giftcard: {
          first: 'Gift card to print is sent after checkout',
          second: 'Redeemable for over {eventCount} konfetti classes',
          third: 'Valid for three years',
        },
        normalTicket: {
          first: 'Your ticket(s) will be send via email',
          second: 'Contact us for questions or help at any time',
          third: 'Tickets are transferrable',
        },
        various: {
          first: 'Gift card to print is sent after checkout',
          second: 'Contact us for questions or help at any time',
          third: 'Tickets are transferrable',
        },
      },
    },
  },
}
